import module from "./dc-scrollbar";
export default module;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-scrollbar/index.js